<template>
	<header>
		<span class="image avatar"><img src="images/avatar.png" alt="" /></span>
		<h1 id="logo"><a href="#">Sam Weru</a></h1>
		<p>Passionate Programmer</p>
	</header>
</template>